import { useSelector, useDispatch } from "react-redux";
import {
  addAchievement,
  addAchievements,
  addEducation,
  addExtraCurricularActivities,
  addExtraCurricularActivity,
  addInterestList,
  addInterests,
  addParentalInfo,
  addStudentContacts,
  addStudentInfo,
  deleteStudentInfo,
  deleteStudentEducation,
  deleteStudentContacts,
  deleteStudentAchievements,
  deleteStudentExtraCurricular,
  getStudentInfo,
  removeAchievement,
  removeEducation,
  removeExtraCurricularActivity,
  removeParentalInfo,
  resetProfileCompleteness,
  resetStudentPersonalInfo,
  searchStudentAction,
  setActiveStudent,
  setProfileCompleteness,
  studentEducation,
  updateAchievement,
  updateEductionInfoItemData,
  updateExtraCurricularActivity,
  updateParentalInfoData,
  updateStudentPersonalInfo,
  updateStudentProfile,
  uploadProfilePic,
  getProgram,
  setOffset,
  setPerPage,
  setPage,
} from "../store/student";

function useStudent() {
  const dispatch = useDispatch();
  const page = useSelector((state) => state.student.page);
  const studentData = useSelector((state) => state.student.data);
  const loading = useSelector((state) => state.student.loading);
  const educationInformation = useSelector(
    (state) => state.student.educationInformation
  );
  const studentPersonalInfo = useSelector(
    (state) => state.student.studentPersonalInfo
  );
  const studentParentalInfo = useSelector(
    (state) => state.student.parentalInfo
  );
  const perPage = useSelector((state) => state.student.perPage);
  const offset = useSelector((state) => state.student.offset);
  const achievementsList = useSelector(
    (state) => state.student.achievementsList
  );
  const extraCurricularActivityList = useSelector(
    (state) => state.student.extraCurricularActivityList
  );
  const interestList = useSelector((state) => state.student.interestList);
  const activeStudent = useSelector((state) => state.student.activeStudent);
  const profileCompleteness = useSelector(
    (state) => state.student?.profileCompleteness
  );
  const activeProfileImage = useSelector(
    (state) => state.student.activeProfileImage
  );
  const program = useSelector((state) => state.student.program);

  const searchStudentService = (params) =>
    dispatch(searchStudentAction(params));
  const addStudentPersonalInfo = (params) => dispatch(addStudentInfo(params));
  const addEducationAction = () => dispatch(addEducation());
  const removeEducationAction = (params) => dispatch(removeEducation(params));
  const updateEductionInfoItemDataAction = (params) =>
    dispatch(updateEductionInfoItemData(params));
  const studentEducationAction = (params) => dispatch(studentEducation(params));
  const resetStudentPersonalInfoAction = () =>
    dispatch(resetStudentPersonalInfo());
  const deleteStudentInfoAction = (params) =>
    dispatch(deleteStudentInfo(params));
  const deleteEduAction = (params) => dispatch(deleteStudentEducation(params));
  const deleteContactAction = (params) =>
    dispatch(deleteStudentContacts(params));
  const deleteAchiveAction = (params) =>
    dispatch(deleteStudentAchievements(params));
  const deleteExtraAction = (params) =>
    dispatch(deleteStudentExtraCurricular(params));
  const addParentalInfoAction = () => dispatch(addParentalInfo());
  const removeParentalInfoAction = (params) =>
    dispatch(removeParentalInfo(params));
  const updateParentalInfoDataAction = (params) =>
    dispatch(updateParentalInfoData(params));
  const addStudentContactsAction = (params) =>
    dispatch(addStudentContacts(params));
  const addAchievementAction = () => dispatch(addAchievement());
  const removeAchievementAction = (params) =>
    dispatch(removeAchievement(params));
  const updateAchievementAction = (params) =>
    dispatch(updateAchievement(params));
  const addAchievementsAction = (params) => dispatch(addAchievements(params));
  const addExtraCurricularActivitiesAction = (params) =>
    dispatch(addExtraCurricularActivities(params));
  const addInterestsAction = (params) => dispatch(addInterests(params));
  const addExtraCurricularActivityAction = (params) =>
    dispatch(addExtraCurricularActivity(params));
  const addInterestListAction = (params) => dispatch(addInterestList(params));
  const removeExtraCurricularActivityAction = (params) =>
    dispatch(removeExtraCurricularActivity(params));
  const updateExtraCurricularActivityAction = (params) =>
    dispatch(updateExtraCurricularActivity(params));
  const updateStudentPersonalInfoAction = (params) =>
    dispatch(updateStudentPersonalInfo(params));
  const getStudentInfoAction = (params) => dispatch(getStudentInfo(params));
  const updateStudentProfileAction = (params) =>
    dispatch(updateStudentProfile(params));
  const setActiveStudentAction = (params) => dispatch(setActiveStudent(params));
  const uploadProfilePicAction = (params) => dispatch(uploadProfilePic(params));
  const setProfileCompletenessAction = (params) =>
    dispatch(setProfileCompleteness(params));
  const resetProfileCompletenessAction = (params) =>
    dispatch(resetProfileCompleteness(params));
  const getProgramAction = (params) => dispatch(getProgram(params));
  const setOffsetAction = (params) => dispatch(setOffset(params));
  const setPerPageAction = (params) => dispatch(setPerPage(params));
  const setPageAction = (params) => dispatch(setPage(params));

  return {
    // states
    studentData,
    loading,
    educationInformation,
    studentPersonalInfo,
    studentParentalInfo,
    achievementsList,
    extraCurricularActivityList,
    interestList,
    activeStudent,
    profileCompleteness,
    activeProfileImage,
    program,
    perPage,
    offset,
    page,
    // actions
    searchStudentService,
    addStudentPersonalInfo,
    addEducationAction,
    removeEducationAction,
    updateEductionInfoItemDataAction,
    studentEducationAction,
    resetStudentPersonalInfoAction,
    deleteStudentInfoAction,
    deleteEduAction,
    deleteContactAction,
    deleteAchiveAction,
    deleteExtraAction,
    addParentalInfoAction,
    removeParentalInfoAction,
    updateParentalInfoDataAction,
    addStudentContactsAction,
    addAchievementAction,
    removeAchievementAction,
    updateAchievementAction,
    addAchievementsAction,
    addExtraCurricularActivitiesAction,
    addInterestsAction,
    addExtraCurricularActivityAction,
    addInterestListAction,
    removeExtraCurricularActivityAction,
    updateExtraCurricularActivityAction,
    updateStudentPersonalInfoAction,
    getStudentInfoAction,
    updateStudentProfileAction,
    setActiveStudentAction,
    uploadProfilePicAction,
    setProfileCompletenessAction,
    resetProfileCompletenessAction,
    getProgramAction,
    setOffsetAction,
    setPerPageAction,
    setPageAction,
  };
}

export default useStudent;
